<template>
  <div class="line">
    <div class="line-box clear">
      <div
        v-for="(line, index) in lineList"
        :key="index"
        class="line-item-box clear"
      >
        <div v-for="(item, index) in line" :key="index" class="line-item">
          <div class="line-head">
            <img :src="item.headImg" alt="headImg" />
          </div>
          <div class="line-cont">
            <div class="v-line-desc text-overflow">
              {{ item.desc }}
            </div>
            <div class="line-cont-desc">{{ item.tag }}</div>
          </div>
          <div v-maidian="'line_' + index" class="line-btm clear">
            <div class="price">
              <span class="price-span">{{
                discount ? item.price * 0.8 : item.price
              }}</span>
              <mt-button @click="jumpToSight(item.linkId)" size="small"
                >预订</mt-button
              >
            </div>
          </div>
        </div>
        <div class="bg-line"></div>
      </div>
    </div>
    <!-- <img class="tip"
      src="https://s.qunarzz.com/srmweb/qunaradv/changma202203/29.png"
      alt=""
    /> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      discount: false,
      lineList: [
        [
          {
            headImg:
              "https://himg1.qunarzz.com/imgs/202205/13/C.lTbfCODSi9V0Dcy2D1024.jpg",
            tagList: ["雪山温泉", "草原"],
            price: 1000,
            tag: "服务贴心/早餐很赞",
            desc: "三亚海棠湾云顶海景空中别墅",
            linkId:
              "https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=sanya_33210",
            discountId: "1678403036",
          },
          {
            headImg:
              "https://source.qunarzz.com/site/images/wns/20220622-shijianchen-4.png",

            tagList: ["海鲜自助", "海岛游"],
            price: 403,
            desc: "小鹿辰客觅度设计美宿(亚龙湾博后村店)",
            tag: "环境舒适/客房干净",
            linkId:
              "https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=sanya_32482",
            discountId: "3770793980",
          },
          {
            headImg:
              "https://source.qunarzz.com/site/images/wns/20220628-shijianchen-changma-1.png",

            tagList: ["海鲜自助", "海岛游"],
            price: 968,
            desc: "杭州千岛湖麓臻品酒店",
            tag:"房间干净/环境舒适",
            linkId: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=hangzhou_50890",
            discountId: "3770793980",
          },
          {
            headImg:
              "https://source.qunarzz.com/site/images/wns/20220622-shijianchen-3.png",
            tagList: ["雪山温泉", "草原"],
            price: 872,
            desc: "杭州隐居江南·运河雅院",
            tag:"位置优越/风景优美",
            linkId: "https://touch.qunar.com/hoteldetail?bd_source=clientshare&seq=hangzhou_18558",
            discountId: "1678403036",
          }
        ],
      ],
    };
  },
  methods: {
    jumpToSight(linkId) {
      location.href = linkId;
    },
  },
};
</script>
<style lang='less' scoped='true'>
.line {
  position: relative;
  top: -36px;
  &-tit {
    width: 100%;
  }
}
.rem(@name,@px) {
  @{name}: unit(@px / 37.5, rem);
}
.line {
  position: relative;
  padding-top: 21px;
  &-box {
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
    width: calc(100% - 24px);
    box-sizing: border-box;
    border-radius: 3px;
  }
  &-item {
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    width: 168px;
    background-color: #fff;
    float: left;
    z-index: 2;
    margin-bottom: 14px;
    height: 199px;
    &-box {
      position: relative;
      margin-bottom: 7px;
      &:last-child {
        margin-bottom: 0;
      }
      // .bg-line {
      //     background: url(https://picbed.qunarzz.com/f85c6e94de1f40c4bae5c5a5c7261be5.png)
      //         no-repeat;
      //     background-size: 100% auto;
      //     height: 20px;
      //     width: 100%;
      //     position: absolute;
      //     left: 0;
      //     bottom: 7px;
      // }
    }
    &:nth-child(2n + 2) {
      float: right;
    }
  }
  &-desc {
    height: 32px;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 5px;
    text-align: left;
  }
  &-tag {
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 3px;
    padding-bottom: 3px;
    border: 0.1em solid #ff414c;
    border-radius: 2px;
    color: #ff414c;
    font-size: 9px;
    float: left;
    margin-right: 5px;
  }
  &-cont {
    padding: 7px;
    padding-top: 2px;
    padding-bottom: 0;
  }
  &-btm {
    padding: 7px;
    .price {
      &-span {
        height: 19px;
        line-height: 19px;
        text-align: left;
        font-size: 16px;
        font-weight: bold;
        float: left;
        color: #ed4834;
        &.discount {
          color: #aaa9a9;
        }
        position: relative;
        &:before {
          content: "￥";
          font-size: 11px;
          position: relative;
        }
        &:after {
          content: "起";
          font-size: 11px;
          position: relative;
        }
      }
      button {
        position: relative;
        float: right;
      }
    }
  }
  &-head {
    img {
      display: block;
      height: 95px;
      width: 100%;
    }
  }
  .price {
    display: flex;
    align-items: center;
  }
  /deep/ .mint-button--small {
    border-radius: 0;
    background-color: #2c517f;
    border-radius: 6px;
    color: #fff;
    font-size: 11px;
    height: 24px;
    margin-left: auto;
  }
  .line-anchor {
    position: absolute;
    left: 0;
    top: 0;
    height: 18px;
    color: #fff;
    font-style: italic;
    text-align: center;
    letter-spacing: 3px;
    background: rgba(255, 63, 79, 1);
    border-radius: 3px 0px 3px 0px;
  }
}
.line-cont-desc {
  font-size: 11px;
  color: #666;
  text-align: left;
  margin-top: 4px;
}
.v-line-desc {
  text-align: left;
  height: 40px;
  font-size: 15px;
}
.tip{
  width:280px;
  display: block;
  margin:0 auto;
}
</style>